var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getProjector, project } from "../utils/projections/projectionHelper";
import { selectPanel, selectPanelByItemId, selectPanelByPage } from "./selectPanelFromDocument";
export function selectSurface({ selector, document }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (selector.type === "page") {
            if (document.projectionId) {
                const projector = yield getProjector(document.projectionId, selector.number);
                return project(projector, document);
            }
            return selectPanelByPage({ document, page: selector.number });
        }
        if (selector.type === "item") {
            return selectPanelByItemId({ document, itemId: selector.id });
        }
        return selectPanel({ document, id: selector.id });
    });
}
//# sourceMappingURL=selectSurface.js.map